/**
 * Simple Date Formatter
 * Formats dates to yyyy-MM-dd format using Luxon
 *
 * Requires Luxon: https://moment.github.io/luxon/
 * Install: npm install luxon
 */

import { DateTime } from "luxon";

/**
 * Format a date to 'yyyy-MM-dd' string
 * @param {Date|string|number} date - Input date (JS Date, ISO string, timestamp, or 'yyyy-MM-dd HH:mm:ss' format)
 * @returns {string} Formatted date string in 'yyyy-MM-dd' format
 */
export const formatDate = (date) => {
  let dt;

  if (date instanceof Date) {
    dt = DateTime.fromJSDate(date);
  } else if (typeof date === "string") {
    // Check if it's in the format 'yyyy-MM-dd HH:mm:ss'
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(date)) {
      dt = DateTime.fromFormat(date, "yyyy-MM-dd HH:mm:ss");
    } else {
      // Try ISO format
      dt = DateTime.fromISO(date);
    }
  } else if (typeof date === "number") {
    dt = DateTime.fromMillis(date);
  } else {
    dt = DateTime.now();
  }

  // Check if the date is valid
  if (!dt.isValid) {
    return "";
  }

  return dt.toFormat("yyyy-MM-dd");
};
